import React, { createContext, useContext, useEffect, useState, useCallback } from "react"
import i18n from "../i18n/config"
import { DEFAULT_LOCALE, LANGUAGES, STORAGE_KEY } from "../i18n/languages"

const SUPPORTED_CODES = LANGUAGES.map((l) => l.code)

const readStoredLocale = () => {
	if (typeof window === "undefined") return DEFAULT_LOCALE
	try {
		const stored = window.localStorage.getItem(STORAGE_KEY)
		if (stored && SUPPORTED_CODES.includes(stored)) return stored
	} catch {
		// localStorage unavailable (private mode, etc.) — fall back silently
	}
	return DEFAULT_LOCALE
}

export const LocaleContext = createContext({
	locale: DEFAULT_LOCALE,
	setLocale: () => {},
	languages: LANGUAGES,
})

export const LocaleProvider = ({ children }) => {
	const [locale, setLocaleState] = useState(readStoredLocale)

	useEffect(() => {
		if (i18n.language !== locale) {
			i18n.changeLanguage(locale)
		}
		if (typeof window !== "undefined") {
			try {
				window.localStorage.setItem(STORAGE_KEY, locale)
			} catch {
				// ignore write failures
			}
		}
	}, [locale])

	const setLocale = useCallback((next) => {
		if (!SUPPORTED_CODES.includes(next)) return
		setLocaleState(next)
	}, [])

	return (
		<LocaleContext.Provider value={{ locale, setLocale, languages: LANGUAGES }}>
			{children}
		</LocaleContext.Provider>
	)
}

export const useLocale = () => useContext(LocaleContext)
